// src/components/FAQ.js

import React, { useState, useEffect } from 'react';

const FAQ = () => {
    // --- STATE MANAGEMENT ---
    const [faqs, setFaqs] = useState([]);
    const [open, setOpen] = useState(1); // Default open first item

    // Fallback Data (In case DB is empty or API fails)
    const fallbackFaqs = [
        {
            id: 1,
            question: "Is this service free for candidates?",
            answer: "Yes. 100% free. Acadfinity does not charge candidates at any stage. Partner schools sponsor the recruitment process."
        },
        {
            id: 2,
            question: "Are these genuine school jobs?",
            answer: "Absolutely. All openings are from verified, partnered schools only. No fake listings, no third-party agents, no scams."
        },
        {
            id: 3,
            question: "How long does it take to get a call?",
            answer: "It depends on your profile and school requirements. Many candidates receive calls within 7–15 days of profile submission."
        },
        {
            id: 4,
            question: "Will my current employer know I'm applying?",
            answer: "Your application is completely confidential. We never share your profile without your consent and take great care to protect your privacy."
        }
    ];

    // --- FETCH DATA FROM API ---
    useEffect(() => {
        fetch('/api/faqs')
            .then(res => res.json())
            .then(data => {
                if (data && data.length > 0) {
                    setFaqs(data);
                    setOpen(data[0].id); // Open first item from DB
                } else {
                    setFaqs(fallbackFaqs);
                }
            })
            .catch(err => {
                console.error('Failed to fetch FAQs:', err);
                setFaqs(fallbackFaqs);
            });
    }, []);

    const toggleFAQ = (id) => {
        if (open === id) {
            setOpen(null); // Close if already open
        } else {
            setOpen(id); // Open clicked item
        }
    };

    return (
        <section id="FAQ" className="py-20">
            <div className="max-w-4xl mx-auto px-4 md:px-8">
                <h2 className="text-3xl font-black !text-brand-dark uppercase tracking-tight text-center mb-12">
                    Frequently Asked Questions
                </h2>
                <div className="space-y-4">
                    
                    {/* Map through FAQs */}
                    {faqs.map((faq) => (
                        <div key={faq.id} className="bg-white p-2 rounded-2xl border border-slate-200">
                            <div
                                onClick={() => toggleFAQ(faq.id)}
                                className="flex justify-between items-center p-4 cursor-pointer select-none"
                            >
                                <h4 className="font-bold text-sm text-brand-dark">{faq.question}</h4>
                                <span className="text-brand-orange font-bold text-lg">
                                    {open === faq.id ? '−' : '+'}
                                </span>
                            </div>
                            {/* Animated Expansion logic or simple conditional rendering */}
                            {open === faq.id && (
                                <div className="px-4 pb-4 text-sm text-slate-500 border-t border-slate-100 pt-4 mt-2 animate-in fade-in slide-in-from-top-1 duration-200">
                                    {faq.answer}
                                </div>
                            )}
                        </div>
                    ))}

                </div>
            </div>
        </section>
    );
};

export default FAQ;